/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  formatDate,
  formatInventory,
  showTodayOrTomorrow,
  showDateOrDateRange,
  isMobile
} from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { IDS } from '../../../../automationTestIds';

const {
  shape, string, bool, number, arrayOf
} = proptypes;

const DefaultBoSS = ({
  fulfillment, backordered, fallbackMode, isSpecialOrder, configuratorHideQuantity, isCartTiles, isBIP
}) => {
  const { channel } = useContext(ExperienceContext);
  const bossLocation = (fulfillment?.locations || []).find((location) => location.type === 'online');
  const quantity = bossLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const startDate = isBIP ? fulfillment?.deliveryDates?.endDate : fulfillment?.deliveryDates?.startDate;
  const endDate = fulfillment?.deliveryDates?.endDate;
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const deliveryEndDate = fulfillment?.deliveryDates?.endDate;
  const deliveryTimeline = fulfillment?.deliveryTimeline;
  return (

    <div>
      <TileHead title="Ship to Store" automationId={IDS.LABEL.stsLabel} />
      <div data-testid="ffm-details-row" className="sui-pt-2">
        <Typography variant="body-base" weight="bold">
          {(startDate || endDate) && (
            formattedStartDate === formattedEndDate ? (
              <div className="sui-font-bold sui-min-h-[24px] sui-pb-1" data-automation-id={IDS.ETA.stsETA}>
                {showTodayOrTomorrow(deliveryEndDate, true, deliveryTimeline, formattedEndDate)}
              </div>
            ) : (
              <div className="sui-font-bold sui-min-h-[24px] sui-pb-1" data-automation-id={IDS.ETA.stsETA}>
                {showDateOrDateRange({ formattedStartDate, formattedEndDate })}
              </div>
            )
          )}
          {(!startDate && !endDate) && (
            <div className="sui-font-bold sui-min-h-[24px] sui-pb-1" data-automation-id={IDS.ETA.stsETA}>
              &nbsp;
            </div>
          )}
        </Typography>
        <Typography variant="body-base">
          {backordered ? (
            <div
              className="sui-min-h-[24px]"
              data-automation-id={IDS.QTY.stsQty}
              data-testid="fulfillment-qty-row"
            >
              Backordered
            </div>
          ) : (((!fallbackMode && !fulfillment?.isBlindsItem) && (!isSpecialOrder && !configuratorHideQuantity))
        && (
          <div
            className="sui-min-h-[24px]"
            data-testid="fulfillment-qty-row"
            data-automation-id={IDS.QTY.stsQty}
          >
            {(parseInt(quantity, 10) > 0) && (
              <div className={isMobile(channel) && formattedInventoryQty.length > 5 ? 'sui-text-sm' : ''}>
                <span className="sui-text-success">{formattedInventoryQty}</span> ready to ship
              </div>
            )}
          </div>
        )
          )}
          {(fallbackMode || fulfillment?.isBlindsItem) && (
            <div
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className="sui-min-h-[24px] sui-pb-1"
              data-testid="fulfillment-qty-row"
              data-automation-id={fallbackMode ? 'isFallback' : 'isBlindsItem'}
            >&nbsp;
            </div>
          )}
        </Typography>

      </div>
      <TileFooter className="sui-font-bold">
        <span className="sui-text-success">FREE</span>
      </TileFooter>
    </div>

  );
};

DefaultBoSS.propTypes = {
  backordered: bool,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }).isRequired,
  fallbackMode: bool,
  isSpecialOrder: bool,
  configuratorHideQuantity: bool,
  isCartTiles: bool,
  isBIP: bool
};

DefaultBoSS.defaultProps = {
  backordered: false,
  fallbackMode: false,
  isSpecialOrder: false,
  configuratorHideQuantity: false,
  isCartTiles: false,
  isBIP: false
};

export { DefaultBoSS };
